(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 57207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ LoginPage; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_forgot_password_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44959);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1283);
/* harmony import */ var custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99109);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var __N_SSP = true;
function LoginPage(props) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_7__.useTranslations)("title-pages");
  var user = (0,custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useAppSelector */ .C)(function (state) {
    return state.Auth.user;
  });

  function onSuccess() {
    router.push(shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.home */ .K.es.home);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (user) router.push(shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.profile */ .K.es.profile);
  });
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("title", null, titleT("forgot-password"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Center, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Content, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_forgot_password_form__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    onClose: onSuccess
  }))));
}

var Center = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "er4q7zo1"
} : 0)( true ? {
  name: "3q2q71",
  styles: "display:grid;place-content:center;height:var(--main-height);padding:20px"
} : 0);

var Content = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "er4q7zo0"
} : 0)( true ? {
  name: "12u3f4i",
  styles: "background-color:white;max-width:600px;padding:70px 20px 20px;border-radius:40px;box-shadow:0px 4px 12px rgba(0, 0, 0, 0.13)"
} : 0);

/***/ }),

/***/ 64923:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(57207);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(64923); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);